// export const baseURL = 'http://192.168.10.163:8080/'
export const baseURL = 'https://www.shengyuaninc.cn/food/'


// 'http://192.168.0.107:8080/'
// 'https://www.ruiyic.com/food/'
